import React from 'react'
import withView from '../../../cmn/docAutomation/withView';
import DocTagSelector from '../../../cmn/DocTagSelector';
import SarasTrans from "../../../../library/notifications/SarasTrans";

const UserRole = (props) => {
    const { formObject, viewData } = props;

    if (!viewData)
        return (null);

    return (
        <div className="uiFlexBox3">
            <span className="uiLbl">
                <SarasTrans value="Roles Assigned" />
            </span>
            <div className="">
                <DocTagSelector formObject={formObject} viewData={viewData} />
            </div>
        </div>
    )
}

export default withView(UserRole, "userRole", "userRole")
